import React from 'react'
import {IncomeDocumentStateTypes} from '../../constants/Common'
import {useLocation} from 'react-router-dom'

const StateLabel = ({state}: {state: string}) => {
  const location = useLocation();
  const isInExpensePage = location.pathname.includes('expense')

  let stateLabel = '-'
  let stateLabelClass = ''
  let stateLabelStyle = {}

  switch (state) {
    case 'draft':
      stateLabel = 'ร่าง'
      stateLabelClass = 'text-muted'
      break
    case 'await-approval':
      stateLabel = 'รออนุมัติ'
      break
    case 'await-accept':
      stateLabel = 'รอตอบรับ'
      stateLabelClass = 'text-info'
      break
    case 'await-deduct':
      stateLabel = 'รอหักมัดจำ'
      break
    case 'approved':
      stateLabel = 'อนุมัติแล้ว'
      stateLabelStyle = {
        color: 'rgb(43,186,102)',
      }
      break
    case 'accepted':
      stateLabel = 'ยอมรับแล้ว'
      stateLabelStyle = {
        color: 'rgb(43,186,102)',
      }
      break
    case 'deducted':
      stateLabel = 'หักมัดจำแล้ว'
      break
    case 'expired':
      stateLabel = 'พ้นกำหนด'
      stateLabelClass = 'text-danger'
      break
    case 'voided':
      stateLabel = 'ยกเลิก'
      stateLabelClass = 'text-danger'
      break
    case 'outstanding':
      // ฝั่งรายจ่ายเราเป็นคนจ่าย — ใช้คำเดียวกับชื่อแท็บ "รอชำระ" (5 ต.ค. 2569)
      stateLabel = isInExpensePage ? 'รอชำระ' : 'รอรับชำระเงิน'
      stateLabelStyle = {
        color: '#ddac00',
      }
      break
    case 'await-receipt':
      stateLabel = isInExpensePage ? 'รอรับใบเสร็จ' : 'รอออกใบเสร็จ'
      stateLabelStyle = {
        color: '#ddac00',
      }
      break
    case 'receive-receipt':
      stateLabel = isInExpensePage ? 'รับใบเสร็จแล้ว' : 'ออกใบเสร็จแล้ว'
      stateLabelStyle = {
        color: 'rgb(43,186,102)',
      }
      break
    case 'overdue':
      stateLabel = isInExpensePage ? 'เกินเวลาชำระ' : 'เกินเวลารับชำระเงิน'
      stateLabelClass = 'text-danger'
      break
    case 'recurring':
      stateLabel = 'เอกสารรายเดือน'
      break
    case 'paid':
      stateLabel = 'รับชำระเงินแล้ว'
      stateLabelStyle = {
        color: 'rgb(43,186,102)',
      }
      break
    case 'completely':
      stateLabel = 'ออกครบแล้ว'
      stateLabelStyle = {
        color: 'rgb(43,186,102)',
      }
      break
    case 'partial':
      stateLabel = 'ออกบางส่วน'
      break
    case 'issued':
      stateLabel = 'ออกแล้ว'
      break
    case 'invoice':
      stateLabel = 'e-Tax Invoice'
      break
  }


  return (
    <div>
      <span className={stateLabelClass} style={stateLabelStyle}>
        {stateLabel}
      </span>
    </div>
  )
}

export default StateLabel
